<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">管理员管理</div>
          <span class="m-title-s">对系统内管理员进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>系统管理员列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增管理员</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="nickname" label="管理员名称" width="220"></el-table-column>
          <el-table-column prop="roleName" label="角色名称" width="220"></el-table-column>
          <el-table-column prop="phone" label="电话" width="130" align="center"></el-table-column>
          <el-table-column prop="loginFlag" label="登录状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.loginFlag === '0'" type="success">正常</el-tag>
              <el-tag v-else type="danger">禁止登录</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="loginDate" label="登录时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column prop="loginIp" label="登录ip" width="110" align="center"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id, scope.row.nickname)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="form.id" type="hidden"></el-input>
            </el-form-item>
            <el-form-item label="管理员名称: " prop="nickname">
              <el-input v-model="form.nickname" placeholder="输入管理员名称"></el-input>
            </el-form-item>
            <el-form-item label="管理员电话: " prop="phone">
              <el-input v-model="form.phone" placeholder="输入管理员电话"></el-input>
            </el-form-item>
            <template v-if="form.id === ''">
              <el-form-item label="初始登录密码: " prop="password">
                <el-input v-model="form.password" placeholder="输入初始登录密码"></el-input>
              </el-form-item>
            </template>
            <el-form-item label="所属角色: " prop="roleId">
              <el-select v-model="form.roleId" placeholder="请选择">
                <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="登录状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="正常" inactive-text="禁止登录"></el-switch>
            </el-form-item>
            <el-form-item label="备注说明: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Manager',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      roleList: [],
      form: {
        id: '',
        phone: '',
        nickname: '',
        loginFlag: '',
        roleId: '',
        remarks: ''
      },
      rules: {
        nickname: [
          { required: true, message: '请输入管理员名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入管理员电话', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入初始登录密码', trigger: 'blur' }
        ],
        roleId: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    closeDialog: function () {
      this.form = {
        id: '',
        phone: '',
        nickname: '',
        loginFlag: '',
        roleId: '',
        remarks: ''
      }
      this.openText = '新增菜单'
      this.openState = false
      this.formLoading = false
      this.$refs['form'].resetFields()
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let reg = /^1[3456789]\d{9}$/
          if (!reg.test(_this.form.phone)) {
            this.$message.error('请输入有效的手机号码')
            _this.formLoading = false
            return
          }
          _this.formLoading = true
          _this.form.loginFlag = _this.isStatus === true ? '0' : '1'
          this.$axios.post('/sys/user/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id, title) {
      let _this = this
      this.$messageBox.confirm('此操作将删除[' + title + '], 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/sys/user/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    openForm (id) {
      let _this = this
      this.openText = '编辑'
      _this.openState = true
      _this.formLoading = true
      this.$axios.post('/sys/user/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            _this.form = res.data
            _this.isLoading = false
            // 判断开启状态，0：开启，1:关闭
            _this.isStatus = _this.form.loginFlag === '0'
            _this.formLoading = false
          } else {
            _this.$message({
              type: 'error',
              duration: '800',
              message: res.msg
            })
          }
        })
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/sys/user/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    },
    roleListData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/sys/role/list')
        .then((res) => {
          _this.roleList = res.data
        })
    }
  },
  mounted () {
    this.listData()
    this.roleListData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sys/Manager.vue